/* eslint-disable no-unused-vars */
import _ from 'underscore';
import React from 'react';

export interface ICheckedAdapterProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  [key: string]: unknown;
}

export class CheckedAdapter {
  component: React.ComponentType<ICheckedAdapterProps>;

  constructor(PrimitiveComponent: React.ComponentType<ICheckedAdapterProps>) {
    this.component = PrimitiveComponent;
  }

  getValue(props: ICheckedAdapterProps): boolean {
    return props.checked;
  }

  renderComponent(props: ICheckedAdapterProps, value: boolean, onChange: (checked: boolean) => void): React.ReactElement {
    const PrimitiveComponent = this.component;

    return (
      <PrimitiveComponent
        {...props}
        checked={value}
        onChange={(checked: boolean) => {
          onChange(checked);
          if (_.isFunction(props.onChange)) {
            props.onChange(checked);
          }
        }}
      />
    );
  }
}
